import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const PostcoderAddressRecord = Record({
  addressline1: '',
  buildingname: '',
  county: '',
  number: '',
  organisation: '',
  postcode: '',
  posttown: '',
  premise: '',
  street: '',
  summaryline: '',
});

export default class PostcoderAddress extends PostcoderAddressRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new PostcoderAddress(hydrated);
  }
}
